export const getImageSizeUrl = (
    sizes: { label: string; url: string }[] | undefined,
    label: string
): string | null | undefined => {
    if (!sizes) return null;

    return sizes.find((size) => size.label === label)?.url;
};
